// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 900px) {
  .width-sm-full {
    width: 100% !important;
  }
  .display-sm-none {
    display: none !important;
  }
  .margin-left-sm-0 {
    margin-left: 0.5rem !important;
  }
  .margin-top-sm {
    margin-top: 0.635rem !important;
  }
  .padding-sm-special {
    padding: 1.3rem !important;
  }
  .padding-sm-1 {
    padding: 1rem !important;
  }
  .padding-sm-0-5 {
    padding: 0.5rem !important;
  }
  .border-radius-5-sm-left {
    border-radius: 5px 0px 0px 5px !important;
  }
  .border-radius-5-sm {
    border-radius: 5px !important;
  }
  .border-radius-5-sm-right {
    border-radius: 0px 5px 5px 0px !important;
  }
  .border-radius-sm-1 {
    border-radius: 1px !important;
  }
  .padding-top-sm {
    padding-top: 0.635rem !important;
  }
  .padding-bottom-sm {
    padding-bottom: 0.635rem !important;
  }
  .padding-left-sm {
    padding-left: 0.635rem !important;
  }
  .padding-right-sm {
    padding-right: 0.635rem !important;
  }
  .margin-left-sm {
    margin-left: 0.635rem !important;
  }
  .margin-right-sm {
    margin-right: 0.635rem !important;
  }
  .margin-bottom-sm {
    margin-bottom: 0.635rem !important;
  }
  .primary-sm-heading {
    font-size: 24px !important;
  }
  .height-unset {
    height: unset !important;
  }
  .secondary-sm-heading {
    font-size: 20px !important;
  }
  .tertiary-sm-heading {
    font-size: 24px !important;
  }
  .super-sm-heading {
    font-size: 32px !important;
  }
  .tertiary-sm-title {
    font-size: 12px !important;
  }
  .btn-sm-orange {
    padding: 8px 10px !important;
  }
  .btn-orange-sm-outline {
    padding: 8px 10px !important;
  }
  .btn-sm-black {
    padding: 8px 10px !important;
  }
  .margin-top-sm-2 {
    margin-top: 2rem !important;
  }
  .margin-outlet-x {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .padding-top-sm-none {
    padding-top: 0px !important;
  }
  .padding-bottom-sm-none {
    padding-bottom: 0px !important;
  }
  .flex-direction-column-sm {
    flex-direction: column !important;
  }
  .min-height-sm-50vh {
    min-height: 50vh !important;
  }
}
@media screen and (max-width: 1200px) {
  .border-radius-50-md-left {
    border-radius: 0px 0px 0px 0px !important;
  }
  .border-radius-50-md-right {
    border-radius: 0px 0px 0px 0px !important;
  }
  .margin-top-sm-2 {
    margin-top: 2rem !important;
  }
  .primary-heading {
    font-size: 24px !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
}
@media screen and (max-width: 900px) {
  .margin-outlet-x {
    margin-left: 0.7rem !important;
    margin-right: 0.7rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/screen-media-query.scss"],"names":[],"mappings":"AAEA;EACE;IACE,sBAAA;EACF;EAEA;IACE,wBAAA;EAAF;EAGA;IACE,8BAAA;EADF;EAIA;IACE,+BAAA;EAFF;EAKA;IACE,0BAAA;EAHF;EAMA;IACE,wBAAA;EAJF;EAMA;IACE,0BAAA;EAJF;EAOA;IACE,yCAAA;EALF;EAQA;IACE,6BAAA;EANF;EASA;IACE,yCAAA;EAPF;EAUA;IACE,6BAAA;EARF;EAWA;IACE,gCAAA;EATF;EAYA;IACE,mCAAA;EAVF;EAaA;IACE,iCAAA;EAXF;EAcA;IACE,kCAAA;EAZF;EAeA;IACE,gCAAA;EAbF;EAgBA;IACE,iCAAA;EAdF;EAiBA;IACE,kCAAA;EAfF;EAkBA;IACE,0BAAA;EAhBF;EAmBA;IACE,wBAAA;EAjBF;EAmBA;IACE,0BAAA;EAjBF;EAoBA;IACE,0BAAA;EAlBF;EAqBA;IACE,0BAAA;EAnBF;EAsBA;IACE,0BAAA;EApBF;EAuBA;IACE,4BAAA;EArBF;EAwBA;IACE,4BAAA;EAtBF;EA2BA;IACE,4BAAA;EAzBF;EA4BA;IACE,2BAAA;EA1BF;EA6BA;IACE,mBAAA;IACA,oBAAA;EA3BF;EA8BA;IACE,2BAAA;EA5BF;EA+BA;IACE,8BAAA;EA7BF;EAgCA;IACE,iCAAA;EA9BF;EAiCA;IACE,2BAAA;EA/BF;AACF;AAoCA;EACE;IACE,yCAAA;EAlCF;EAqCA;IACE,yCAAA;EAnCF;EAsCA;IACE,2BAAA;EApCF;EAuCA;IACE,0BAAA;EArCF;EAwCA;IACE,iCAAA;EAtCF;AACF;AAyCA;EACE;IACE,8BAAA;IACA,+BAAA;EAvCF;AACF","sourcesContent":["@import \"./variables\";\n\n@media screen and (max-width:900px) {\n  .width-sm-full {\n    width: 100% !important;\n  }\n\n  .display-sm-none {\n    display: none !important;\n  }\n\n  .margin-left-sm-0 {\n    margin-left: 0.5rem !important;\n  }\n\n  .margin-top-sm {\n    margin-top: 0.635rem !important;\n  }\n\n  .padding-sm-special {\n    padding: 1.3rem !important;\n  }\n\n  .padding-sm-1 {\n    padding: 1rem !important;\n  }\n  .padding-sm-0-5 {\n    padding: .5rem !important;\n  }\n\n  .border-radius-5-sm-left {\n    border-radius: $border-radius-5 0px 0px $border-radius-5 !important\n  }\n\n  .border-radius-5-sm {\n    border-radius: $border-radius-5 !important\n  }\n\n  .border-radius-5-sm-right {\n    border-radius: 0px $border-radius-5 $border-radius-5 0px !important\n  }\n\n  .border-radius-sm-1{\n    border-radius: 1px !important;\n  }\n\n  .padding-top-sm {\n    padding-top: 0.635rem !important;\n  }\n\n  .padding-bottom-sm {\n    padding-bottom: 0.635rem !important;\n  }\n\n  .padding-left-sm {\n    padding-left: 0.635rem !important;\n  }\n\n  .padding-right-sm {\n    padding-right: 0.635rem !important;\n  }\n\n  .margin-left-sm {\n    margin-left: 0.635rem !important;\n  }\n\n  .margin-right-sm {\n    margin-right: 0.635rem !important;\n  }\n\n  .margin-bottom-sm {\n    margin-bottom: 0.635rem !important;\n  }\n\n  .primary-sm-heading {\n    font-size: $secondary-heading !important;\n  }\n\n  .height-unset {\n    height: unset !important;\n  }\n  .secondary-sm-heading {\n    font-size: $heading-20 !important;\n  }\n\n  .tertiary-sm-heading {\n    font-size: $secondary-heading !important;\n  }\n\n  .super-sm-heading {\n    font-size: $primary-heading !important;\n  }\n\n  .tertiary-sm-title {\n    font-size: $tertiary-title !important;\n  }\n\n  .btn-sm-orange {\n    padding: 8px 10px !important;\n  }\n\n  .btn-orange-sm-outline {\n    padding: 8px 10px !important;\n  }\n\n\n\n  .btn-sm-black {\n    padding: 8px 10px !important;\n  }\n\n  .margin-top-sm-2 {\n    margin-top: 2rem !important;\n  }\n\n  .margin-outlet-x {\n    margin-left: .5rem;\n    margin-right: .5rem;\n  }\n\n  .padding-top-sm-none {\n    padding-top: 0px !important;\n  }\n\n  .padding-bottom-sm-none {\n    padding-bottom: 0px !important;\n  }\n\n  .flex-direction-column-sm {\n    flex-direction: column !important;\n  }\n\n  .min-height-sm-50vh {\n    min-height: 50vh !important;\n  }\n\n\n}\n\n@media screen and (max-width:1200px) {\n  .border-radius-50-md-left {\n    border-radius: 0px 0px 0px 0px !important;\n  }\n\n  .border-radius-50-md-right {\n    border-radius: 0px 0px 0px 0px !important;\n  }\n\n  .margin-top-sm-2 {\n    margin-top: 2rem !important;\n  }\n\n  .primary-heading {\n    font-size: $secondary-heading !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n}\n\n@media screen and (max-width:900px) {\n  .margin-outlet-x {\n    margin-left: .7rem !important;\n    margin-right: .7rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
